module.exports = __webpack_public_path__ + "static/media/photo3.b285c4f8.jpg";